export default __webpack_public_path__ + "static/media/140.a4e7f7eb.svg";